import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import { init } from "../../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "./all_routes";
import { AppDispatch, RootState } from "../../redux/store";
import SchoolLogin from "../auth/login/school-login";
import SuperAdminLogin from "../auth/login/superadmin-login";

const ALLRoutes: React.FC = () => {
  const { authenticated } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  // useEffect(() => {
  //   if (!authenticated && !location.pathname.includes("superadmin")) {
  //     dispatch(
  //       init(
  //         navigate,
  //         () => {
  //           if (location.pathname.includes("login") || location.pathname === "/") {
  //             navigate(location.pathname);
  //           }
  //         },
  //         () => {
  //           if (
  //             location.pathname.includes("login") ||
  //             location.pathname.includes("application")
  //           ) {
  //             navigate(location.pathname);
  //           } else {
  //             navigate(all_routes.login);
  //           }
  //         }
  //       )
  //     );
  //   }
  // }, [authenticated, dispatch, navigate, location.pathname]);

  useEffect(() => {
    // const isSchoolLogin = /^\/[A-Z]+\/SCH\/\d+$/.test(location.pathname);

    if (
      !authenticated
    ) {
      dispatch(
        init(
          navigate,
          () => {
            if (
              location.pathname.includes("login") ||
              location.pathname === "/"
            ) {
              navigate(location.pathname);
            }
          },
          () => {
            if (
              location.pathname.includes("login") ||
              location.pathname.includes("application")
            ) {
              navigate(location.pathname);
            } else if (location.pathname.includes("superadmin")) {
              navigate(all_routes.superAdminLogin);
            }
          }
        )
      );
    }
  }, [authenticated, dispatch, navigate, location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/:short_name/SCH/:school_id" element={<SchoolLogin />} />
        <Route path="/superadmin" element={<SuperAdminLogin />} />
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
